/**
 * Google Analytics Integration
 * Only loads if user has given consent (GDPR compliant)
 */

let analyticsInitialized = false
let gtag = null

/**
 * Initialize Google Analytics
 * Only call this after user has given consent
 */
export function initAnalytics() {
  // Don't initialize if already done or if no consent
  if (analyticsInitialized) {
    return
  }

  // Get Google Analytics ID from environment variable
  const GA_ID = process.env.VUE_APP_GA_ID

  if (!GA_ID || GA_ID === 'YOUR_GA_ID') {
    console.warn('Google Analytics ID not configured. Set VUE_APP_GA_ID in your .env file.')
    return
  }

  // Create script element for Google Analytics
  const script1 = document.createElement('script')
  script1.async = true
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`
  document.head.appendChild(script1)

  // Initialize gtag
  window.dataLayer = window.dataLayer || []
  function gtag() {
    window.dataLayer.push(arguments)
  }
  gtag('js', new Date())
  gtag('config', GA_ID, {
    anonymize_ip: true, // GDPR: anonymize IP addresses
    cookie_flags: 'SameSite=None;Secure' // Secure cookies
  })

  window.gtag = gtag
  gtag = window.gtag
  analyticsInitialized = true

  console.log('Google Analytics initialized (with consent)')
}

/**
 * Remove Google Analytics
 * Called when user revokes consent
 */
export function removeAnalytics() {
  if (!analyticsInitialized) {
    return
  }

  // Remove gtag script
  const scripts = document.querySelectorAll('script[src*="googletagmanager.com"]')
  scripts.forEach(script => script.remove())

  // Clear dataLayer
  if (window.dataLayer) {
    window.dataLayer = []
  }

  // Remove gtag function
  if (window.gtag) {
    delete window.gtag
  }

  // Remove cookies set by Google Analytics
  const cookies = document.cookie.split(';')
  cookies.forEach(cookie => {
    const eqPos = cookie.indexOf('=')
    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim()
    if (name.startsWith('_ga') || name.startsWith('_gid') || name.startsWith('_gat')) {
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname}`
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.${window.location.hostname}`
    }
  })

  analyticsInitialized = false
  console.log('Google Analytics removed')
}

/**
 * Track page view
 * Call this when route changes
 */
export function trackPageView(path) {
  if (!analyticsInitialized || !window.gtag) {
    return
  }

  window.gtag('config', process.env.VUE_APP_GA_ID, {
    page_path: path
  })
}

